/** @format */

import React, { useContext, useState, useEffect } from "react";
import { useParams } from "react-router-dom";

import Nav from "react-bootstrap/Nav";
import Table from "react-bootstrap/Table";
import { DataContext } from "../context/DataContext";
import Footer from "../components/Footer";

import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import WatchLaterIcon from "@material-ui/icons/WatchLater";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import asistenciaIcon from "../assets/img/lista-de-verificacion 1.svg";
import notasIcon from "../assets/img/notasIcon.svg";

/* Begin By Javi */
import utils from "./../util";
import alertify from "alertifyjs";
import Header from "./Header";
import { Loader } from "../util/loader";
import { getStorage, getStorageList } from "../util/auth";
import { apiNotas, apiAsistencia } from "../api";
/* End By Javi */

let codigo = 0;
const { isMobile } = utils;
export const DetalleCurso = () => {
  /* Begin By Javi */
  const [_isMobile] = useState(isMobile());
  const [Loading, setloading] = useState(true);
  let dataStorage = getStorage("studientActive");
  let dataListStorage = getStorageList("studientList");
  const { data, setData } = useContext(DataContext);
  const alertMessage = "Notificación de Notas";
  const alertMessage1 = "Notificación de Asistencia";
  /* End By Javi */

  const [notas, setNotas] = useState([]);
  const [asistencias, setAsistencias] = useState([]);
  let { courseId, courseSection, period } = useParams();
  const [showNotas, setShowNotas] = useState(true);

  const getDataNotas = () => {
    setShowNotas(true);
    setloading(true);
    codigo =
      data == undefined || data.student == undefined
        ? dataStorage.Codigo
        : data.student.Codigo;
    let ObjNota = {
      codigo: codigo,
      courseId: courseId,
      courseSection: courseSection,
      period: period,
    };
    console.log("ObjNota", ObjNota);
    const promise = apiNotas.listar(ObjNota, alertMessage);
    promise.then((res) => {
      setloading(false);
      if (res != undefined) {
        setNotas(res.gradeArray);
      }
    });
  };

  const getDataAsistencia = () => {
    setShowNotas(false);
    setloading(true);
    codigo =
      data == undefined || data.student == undefined
        ? dataStorage.Codigo
        : data.student.Codigo;
    let ObjNota = {
      codigo: codigo,
      courseId: courseId,
      courseSection: courseSection,
      period: period,
    };
    const promise = apiAsistencia.listar(ObjNota, alertMessage1);

    promise.then((res) => {
      setloading(false);
      if (res != undefined) {
        setAsistencias(res.sessionArray);
      }
    });
  };
  const ActiveAlummno = () => {
    console.log("courseSection", dataStorage);
    showNotas ? getDataNotas() : getDataAsistencia();
  };

  useEffect(
    () => {
      setData({ ...data, students: dataListStorage, student: dataStorage });
      if (
        dataStorage == undefined ||
        (data == undefined && dataListStorage.length != 1)
      ) {
        setloading(false);
        alertify
          .alert("Debe seleccionar un Estudiante")
          .setHeader(alertMessage);
        return;
      }
      getDataNotas();
    },
    [setData],
    [setAsistencias]
  );
  const callStates = (param) => {
    switch (param) {
      case "A":
        return (
          <CheckCircleIcon
            style={{ color: "#0AAF7E" }}
            className="with-citcle"
          />
        );
      case "F":
        return <CancelIcon style={{ color: "#D01D1D" }} />;
      default:
        return "foo";
    }
  };

  return (
    <div>
      {Loader(Loading)}
      <dvi className="contend">
        <div className={"text col-12"}>
          <Header
            objData={data}
            page={"D"}
            redir={"/curso"}
            Title={"Detalle de Cursos"}
            objActiveAlummno={ActiveAlummno}
            isMobile={_isMobile}
          />
          <div className=" mt-4 ">
            <div className="notas-asistencia">
              <Nav
                style={{ borderBottom: "0.2em solid #404041" }}
                fill
                variant="tabs"
                defaultActiveKey="/curso"
              >
                <Nav.Item>
                  <Nav.Link
                    className={showNotas ? "tab-cursos" : "tab-no-select"}
                    onClick={() => {
                      getDataNotas();
                    }}
                  >
                    <div className="ir-perfil card-title-notas font-weight-600">
                      <img src={notasIcon} className="mr-2" />
                      NOTAS
                    </div>
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link
                    className={!showNotas ? "tab-cursos" : "tab-no-select"}
                    onClick={() => {
                      getDataAsistencia();
                    }}
                  >
                    <div className="ir-perfil card-title-notas font-weight-600">
                      <img src={asistenciaIcon} className="mr-2" />
                      ASISTENCIA
                    </div>
                  </Nav.Link>
                </Nav.Item>
              </Nav>
            </div>
            <div>
              {showNotas ? (
                <Table striped hover className="table-detail">
                  <thead className="background-sub-cursos">
                    <tr>
                      <th style={{ width: "65%", textAlign: "left" }}>
                        <div className="sub-cursos-div ">Pauta Evaluación</div>
                      </th>
                      <th style={{ width: "20%", textAlign: "right" }}>
                        <div className="sub-cursos-div">Nota</div>
                      </th>
                      <th style={{ width: "15%", textAlign: "right" }}>
                        <div className="sub-cursos-div">Peso</div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <>
                      {notas == undefined ? (
                        <td colSpan={4} style={{ textAlign: "center" }}>
                          No existen notas...
                        </td>
                      ) : (
                        notas.map((nota, i) => {
                          return nota.gradeType != "PF" ? (
                            <tr key={i}>
                              <td style={{ width: "65%", textAlign: "Left" }}>
                                {nota.gradeTypeDesc} ({nota.gradeType})
                              </td>
                              <td
                                data-toggle="tooltip"
                                data-placement="top"
                                title="No Rindio"
                                style={{ width: "10%", textAlign: "right" }}
                              >
                                {nota.gradeTypeDesc == "SUSTITUTORIO"
                                  ? "N/R"
                                  : nota.gradeValue}
                              </td>
                              <td style={{ width: "10%", textAlign: "right" }}>
                                {nota.gradeTypeDesc == "SUSTITUTORIO"
                                  ? " - "
                                  : nota.gradeAverage}
                                {/* {nota.gradeAverage.toFixed(2)} */}
                              </td>
                            </tr>
                          ) : null;
                        })
                      )}
                      {notas != undefined
                        ? notas
                            .filter((u) => u.gradeType == "PF")
                            .map((nota, i) => {
                              return nota.gradeType == "PF" ? (
                                <tr key={i} className="font-weight-bold">
                                  <td
                                    style={{
                                      width: "65%",
                                      textAlign: "Left",
                                    }}
                                  >
                                    {" "}
                                    {nota.gradeTypeDesc} ({nota.gradeType})
                                  </td>
                                  <td
                                    style={{
                                      width: "10%",
                                      textAlign: "right",
                                    }}
                                  >
                                    {" "}
                                    {nota.gradeValue}{" "}
                                  </td>
                                  <td
                                    style={{
                                      width: "10%",
                                      textAlign: "right",
                                    }}
                                  >
                                    {" "}
                                    {nota.gradeAverage}
                                  </td>
                                </tr>
                              ) : (
                                <td colSpan={4} style={{ textAlign: "center" }}>
                                  No existen notas...
                                </td>
                              );
                            })
                        : null}
                    </>
                  </tbody>
                </Table>
              ) : (
                <>
                  <div className="estado-curso ">
                    <ul className="list-group list-group-horizontal">
                      <li className="margin-list-estudent">
                        <CheckCircleIcon
                          style={{ color: "#0AAF7E" }}
                          className="with-citcle"
                        />
                        <span>Asistencia</span>
                      </li>
                      <li className="margin-list-estudent">
                        <WatchLaterIcon style={{ color: "#FDC85C" }} />
                        <span>Tardanza</span>
                      </li>
                      <li className="margin-list-estudent">
                        <RemoveCircleIcon style={{ color: "#7C858C" }} />
                        <span>Sin Asistencia</span>
                      </li>
                      <li className="margin-list-estudent">
                        <CancelIcon style={{ color: "#D01D1D" }} />
                        <span>Falta</span>
                      </li>
                    </ul>
                  </div>
                  <Table striped hover>
                    <thead className="background-sub-cursos">
                      <tr>
                        <th>
                          <div align="center">Fecha</div>
                        </th>
                        <th>
                          <div align="center">Hora Inicio</div>
                        </th>
                        <th>
                          <div align="center">Hora Fin</div>
                        </th>
                        <th>
                          <div align="center">Estado</div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {asistencias == null || asistencias == undefined ? (
                        <td colSpan={4} style={{ textAlign: "center" }}>
                          No existen asistencias...
                        </td>
                      ) : (
                        asistencias.map((asistencia, i) => {
                          return (
                            <tr key={i}>
                              <td align="center">{asistencia.date}</td>
                              <td align="center">{asistencia.timeStart}</td>
                              <td align="center">{asistencia.timeEnd}</td>
                              <td align="center">
                                {callStates(asistencia.attendanceState)}
                              </td>
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </Table>
                </>
              )}
            </div>
          </div>
        </div>
      </dvi>
    </div>
  );
};
